import '../src/style/index.scss';
import { getRoutes } from '../src/routes/routes';
import createApp from '@om-fe/core/client/client';
import { CustomAppProps } from '@om-fe/core/app/app';
import { logError } from '@om-fe/core/utils/trackjs';

const customAppProps: CustomAppProps = {
    getRoutes,
};

createApp(customAppProps)
    .catch(logError);
